import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { IdealWeight_EndPoint } from "./ConstantsHealthCalculator";
import IdealWeightTable from "./IdealWeightTable";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice du poids ideal selon votre taille";
const DESCRIPTION =
  "Estimez une plage de poids ideal a partir de votre taille et de votre sexe avec plusieurs formules de reference. Pratique pour fixer un objectif de poids coherent.";
const KEYWORDS =
  "poids ideal, calculatrice poids ideal, poids sante, objectif de poids, formule devine hamwi robinson miller";
const OG_URL = "https://do-calculate.com/calculator/fr/ideal-weight/";
const apiEndpoint = `${SERVER_URL}/${IdealWeight_EndPoint}`;

function IdealWeightCalculator() {
  const [height, setHeight] = useState("");
  const [gender, setGender] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const calculateIdealWeight = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ height, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setResult(data.result);
        setError(null);
      } else {
        setResult(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
      setError("Erreur lors du calcul");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Le poids idéal varie en fonction de plusieurs facteurs, notamment votre taille, votre âge et votre sexe. Bien qu'il n'existe pas de "poids idéal" unique pour tout le monde, cette calculatrice vous permet d'obtenir une plage de poids sain basée sur votre taille et votre sexe.
                </p>
                <p>
                  Maintenir un poids sain est important pour votre santé générale et peut réduire le risque de maladies chroniques telles que le diabète, les maladies cardiaques et certains types de cancer.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Calculatrice du poids idéal
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Taille
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="gender" className="form-label ms-2">
                      Sexe
                    </label>
                  </b>
                  <select
                    id="gender"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="">Sélectionner...</option>
                    <option value="male">Homme</option>
                    <option value="female">Femme</option>
                  </select>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateIdealWeight}
                    disabled={isLoading}
                  >
                    {isLoading ? "Calcul..." : "Calculer"}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b><u> Erreur :</u></b>{" "}
                    Veuillez entrer une taille valide{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>Résultats :</h5>
                    </div>
                    <hr />
                    <IdealWeightTable result={result}></IdealWeightTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
          </div>
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Considerez le resultat comme une plage indicative, pas comme une obligation. La composition corporelle, l'activite physique et votre contexte medical restent essentiels pour definir un objectif realiste.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Le poids idéal : tout ce que vous devez savoir</h2>
              </div>
              <div className="info-section-body">
                <p>
                  Le poids idéal est le poids considéré comme optimal pour votre santé en fonction de votre taille, votre âge et votre sexe. Connaître votre poids idéal peut être une étape importante vers une vie saine et active. Cette calculatrice utilise 4 formules différentes :
                </p>
                <div>
                  <b>G. J. Hamwi Formula (1964)</b>
                  <br />
                  Cette formule propose une plage acceptable et a été largement utilisée en médecine. Elle est calculée comme suit :
                  <div className="alert alert-info">
                    <ul>
                      <li>Hommes : poids idéal (kg) = 48 kg + 2,7 kg par cm au-dessus de 152 cm</li>
                      <li>Femmes : poids idéal (kg) = 45,5 kg + 2,2 kg par cm au-dessus de 152 cm</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <b>B. J. Devine Formula (1974)</b>
                  <br />
                  Devine a établi qu'un homme de 152 cm devrait peser 50 kg, et une femme de même taille 45,5 kg. Pour chaque centimètre supplémentaire, le poids idéal est ajusté de 2,3 kg.
                  <div className="alert alert-info">
                    <ul>
                      <li>Hommes : 50,0 kg + 2,3 kg par cm au-dessus de 152 cm</li>
                      <li>Femmes : 45,5 kg + 2,3 kg par cm au-dessus de 152 cm</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <b>J. D. Robinson Formula (1983)</b>
                  <br />
                  Robinson a repris la formule de Devine et l'a soumise à des données expérimentales, ajustant les valeurs de base.
                  <div className="alert alert-info">
                    <ul>
                      <li>Hommes : 52 kg + 1,9 kg par cm au-dessus de 152 cm</li>
                      <li>Femmes : 49 kg + 1,7 kg par cm au-dessus de 152 cm</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <b>D. R. Miller Formula (1983)</b>
                  <br />
                  La formule de Miller calcule le poids idéal en fonction de la taille, mais ne prend pas en compte d'autres facteurs comme la masse musculaire.
                  <div className="alert alert-info">
                    <ul>
                      <li>Hommes : 56,2 kg + 1,41 kg par cm au-dessus de 152 cm</li>
                      <li>Femmes : 53,1 kg + 1,36 kg par cm au-dessus de 152 cm</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <b>Plage IMC saine</b>
                  <br />
                  L'OMS recommande un IMC sain entre 18,5 et 25 pour les hommes et les femmes. C'est un indicateur largement utilisé en médecine pour évaluer les risques de complications de santé.
                </div>
                <hr />
                <h3 style={{ fontSize: "16px" }}>Importance du poids idéal pour la santé :</h3>
                <p>
                  Le poids idéal a un impact significatif sur votre santé. Un excès de poids peut augmenter le risque de maladies cardiovasculaires, de diabète et d'hypertension artérielle. À l'inverse, un poids insuffisant peut exposer à des problèmes tels que l'ostéoporose et la malnutrition.
                </p>
                <h3 style={{ fontSize: "16px" }}>Conclusion :</h3>
                <p>
                  Le poids idéal n'est pas qu'un chiffre sur une balance. Il dépend de nombreux facteurs personnels incluant la taille, l'âge, le sexe et les objectifs de santé. Consultez toujours un médecin avant de suivre un régime ou un programme de gestion du poids.
                </p>
              </div>
            </div>

            <br />
            <h2 style={{ fontSize: "16px" }}>Questions fréquentes</h2>
            <br />

            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Combien pèse votre corps ?</h3>
              </div>
              <div className="info-section-body">
                Le sang dans votre corps représente environ 7 % de votre poids total.<br />
                Vos os représentent 15 %.<br />
                Vos muscles représentent entre 25 et 50 % de votre poids corporel.<br />
                Le pourcentage de graisse peut aller de 6 % (pour les hommes athlètes) à 31 % pour les femmes (moyenne) et 24 % pour les hommes (également une moyenne).<br />
                Lorsque la graisse corporelle dépasse 32 % pour les femmes et 25 % pour les hommes, on parle d'obésité. Cependant, comme les muscles représentent une grande part du poids, le chiffre sur la balance n'est pas toujours le meilleur indicateur, surtout si vous pratiquez une musculation intensive régulière.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Que signifie un poids sain ?</h3>
              </div>
              <div className="info-section-body">
                Un poids sain signifie que vous avez un équilibre sain entre la graisse, les muscles et les os, ce qui peut varier légèrement d'une personne à l'autre. Par exemple, selon votre constitution génétique, votre « poids sain » peut différer des recommandations officiellesde santé.<br />
                Si vous avez un petit gabarit avec un excès de poids important, vous pourriez être considéré dans la plage de poids sain simplement parce que votre gabarit compense le chiffre.<br />
                De même, si vous avez des os larges, cela peut aussi affecter le chiffre sur la balance, vous faisant paraître plus lourd que vous ne l'êtes réellement.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Combien dois-je peser ?</h3>
              </div>
              <div className="info-section-body">
                Le poids idéal pour une personne n'est pas une règle stricte. Il dépend fortement de chaque individu. À ce jour, aucune mesure, que ce soit l'IMC ou d'autres mesures, ne peut déterminer définitivement combien une personne devrait peser pour être en bonne santé. Ce sont des références uniquement. L'essentiel est d'adopter de bonnes habitudes : exercice régulier, alimentation variée non transformée, sommeil suffisant.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Comment l'âge affecte-t-il le poids idéal ?</h3>
              </div>
              <div className="info-section-body">
                En théorie, l'âge ne devrait pas être un facteur majeur dans le poids idéal après 14-15 ans pour les filles et 16-17 ans pour les garçons, après quoi la plupart des personnes cessent de grandir. On s'attend à ce que les hommes et les femmes perdent respectivement environ 4 et 5 cm de taille d'ici l'âge de 70 ans. Avec l'âge, la masse musculaire diminue et il devient plus facile d'accumuler des graisses. Des habitudes saines comme surveiller l'alimentation, faire de l'exercice, gérer le stress et dormir suffisamment peuvent atténuer ces effets.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Comment le sexe affecte-t-il le poids idéal ?</h3>
              </div>
              <div className="info-section-body">
                En général, les femmes pèsent moins que les hommes même si elles ont naturellement un pourcentage de graisse corporelle plus élevé. Le corps masculin porte généralement plus de masse musculaire, et les muscles sont plus lourds que la graisse. De plus, les femmes ont généralement une densité osseuse plus faible. Enfin, les hommes ont tendance à être plus grands que les femmes.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Comment la taille affecte-t-elle le poids idéal ?</h3>
              </div>
              <div className="info-section-body">
                Plus une personne est grande, plus elle a de masse musculaire et de graisse dans son corps, ce qui entraîne un poids plus élevé. Un homme de la même taille qu'une femme devrait peser environ 10 à 20 % de plus.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Comment la morphologie affecte-t-elle le poids idéal ?</h3>
              </div>
              <div className="info-section-body">
                La morphologie (petite, moyenne ou grande ossature) peut influencer considérablement le poids idéal. Elle est généralement évaluée en fonction du tour de poignet par rapport à la taille. Une personne avec une grande ossature aura naturellement un poids plus élevé qu'une personne avec une petite ossature, même à taille égale, ce qui rend la morphologie un facteur pouvant affecter les mesures comme l'IMC.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Quels sont les effets d'un poids inadapté sur la santé des femmes ?</h3>
              </div>
              <div className="info-section-body">
                Un poids insuffisant, excessif ou l'obésité augmentent vos risques de nombreux problèmes de santé sérieux :<br />
                - Troubles du cycle menstruel. Une perte de poids excessive peut entraîner l'arrêt ou l'irrégularité des menstruations.<br />
                - Ostéoporose. Un poids insuffisant augmente le risque d'ostéoporose, une maladie qui fragilise les os.<br />
                - Dépression. Des études indiquent que la dépression est plus fréquente chez les femmes de poids insuffisant que chez celles ayant un poids sain.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Conseils pour perdre du poids avec succès</h3>
              </div>
              <div className="info-section-body">
                La vitesse à laquelle vous pouvez prendre ou perdre du poids peut varier considérablement d'une personne à l'autre. Essayez ces conseils :<br />
                - Fixez des objectifs réalistes. Parlez à votre médecin de vos objectifs et de la façon de les atteindre.<br />
                - Planifiez vos repas à l'avance et cuisinez davantage à la maison.<br />
                - Concentrez-vous sur les aliments sains. Obtenir des calories principalement à partir de protéines végétales, de céréales complètes, de fruits et légumes peut vous aider à perdre du poids de façon sûre.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Comment le poids affecte-t-il la santé ?</h3>
              </div>
              <div className="info-section-body">
                Si vous êtes en surpoids ou obèse, vous risquez de développer des problèmes de santé liés à ce poids, notamment :<br />
                - Maladies cardiovasculaires.<br />
                - Hypertension artérielle.<br />
                - AVC.<br />
                - Diabète de type 2.<br />
                - Ostéoporose.<br />
                - Goutte.<br />
                - Certains types de cancer.<br />
                - Asthme.<br />
                - Apnée du sommeil.<br />
                - Problèmes de fertilité chez les hommes et les femmes.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IdealWeightCalculator;
